<template>
  <Head :title="__('Password reset')" />

  <div class="min-h-screen flex flex-col lg:flex-row bg-white">
    <div class="relative hidden lg:flex lg:flex-1">
      <img :src="startSplash" alt="Password Reset Splash" class="h-full w-full object-cover" />

      <div class="absolute top-6 left-8 flex items-center gap-3 text-white">
        <img :src="loginLogo" alt="Logo" class="h-12 w-auto" />
      </div>
    </div>

    <div class="flex flex-col w-full lg:w-[450px] bg-white min-h-screen lg:min-h-auto">
      <div class="flex lg:hidden items-center justify-center pt-8">
        <img :src="loginLogo" alt="Logo" class="h-10 w-auto" />
      </div>

      <div class="flex-1 flex items-center justify-center px-6 py-10 lg:px-8">
        <div class="w-full max-w-md">
          <div class="mb-8 text-center">
            <h1 class="text-2xl font-semibold text-gray-900">Resetowanie hasła</h1>
            <p class="mt-2 text-sm text-gray-500">Wpisz poniżej adres e-mail, aby otrzymać link do resetowania hasła</p>
          </div>

          <v-form name="formForget" class="space-y-5" @keyup.enter="send">
            <div v-if="success" class="p-3 text-center text-sm font-medium text-green-700 bg-green-50 border border-green-200 rounded-md">
              {{ __('Link was send') }}
            </div>

            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 mb-1">{{ __('E-Mail Address') }}</label>
              <InputText
                id="email"
                type="text"
                size="small"
                class="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-secondary-500/50"
                :class="{ 'border-gray-300': !form.errors.email, 'border-red-400': form.errors.email }"
                v-model="form.email"
                @input="inputNewData"
              />
              <div v-if="form.errors.email" class="mt-1 text-xs text-red-500">
                {{ __(form.errors.email) }}
              </div>
            </div>

            <div class="flex flex-col gap-2 mt-4">
              <Button
                @click="send"
                :label="__('Send Password Reset Link')"
                icon="pi pi-sign-in"
                class="w-full justify-center rounded-md bg-secondary-500 px-4 py-2 text-sm font-medium text-white hover:bg-secondary-700 transition-colors"
              />
            </div>

            <div class="mt-4 flex items-center justify-center">
              <Link v-if="route().has('app-login')" :href="route('app-login')" class="inline-flex items-center gap-2 text-secondary-600 hover:text-secondary-700 hover:underline text-sm">
                <i class="pi pi-star text-secondary-400 text-xs"></i>
                <span>{{ __('Login') }}</span>
              </Link>
            </div>
          </v-form>
        </div>
      </div>

      <footer class="px-4 py-4 text-sm text-gray-500">
        <div class="text-center">
          <p class="font-light">Powered by © 4Evolve wersja 1.0</p>
          <p class="text-xs text-gray-400 mt-1">rewizja {{ systemRevision }}</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useForm } from '@inertiajs/vue3';
import { Head } from '@inertiajs/vue3';
import { Link } from '@inertiajs/vue3';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Layout from '@layouts/LayoutNoMenuNoFooter.vue';
import Image from '@helper/Image.vue';
import { __ } from '@helper/utils.js';
import { loginLogo, developerLogo } from '@helper/constants.js';

defineOptions({ layout: Layout });

const success = ref(false);
const form = useForm({ email: '' });

const inputNewData = () => {
  form.errors.email = null;
  success.value = false;
};

const send = () => {
  form.post(route('password.email'), {
    onSuccess: () => {
      success.value = true;
      form.email = '';
    },
    onError: (errors) => {
      console.error(errors);
    },
  });
};
</script>
